import {Carousel} from "react-bootstrap";
import Utils from "./BackendService/Utils";

const CarouselComponent = (props: { imageUrls: string[] }) => {
    return (
        <div>
            <Carousel interval={3000} style={{height: 600, objectFit: "fill"}}>
                {
                    props.imageUrls.map((imgUrl) => (
                        <Carousel.Item>
                            <img
                                style={{objectFit: "fill", width: "100%", height: 600}}
                                src={Utils.completePathToImage(imgUrl)}
                                alt={"fotka produktu"}
                            />
                        </Carousel.Item>
                    ))
                }
            </Carousel>
        </div>
    )
}

export default CarouselComponent;